module.exports = __webpack_public_path__ + "static/media/agent-bg.51f5e670.png";